/*
 * How to set up a new conversion tracking: https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking
 * Event names, event object properties and types: https://developers.facebook.com/docs/meta-pixel/reference#object-properties
 */
import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { formatMetaClickId } from '../../../../util/socialMediaMarketing.util.js';
import { cookieService } from '../../../cookie.service.js';
import { PixelClickIdCookie } from '../../socialMediaMarketing.model.js';
import { metaPixel } from './meta.pixel.js';
let MetaClient = /*#__PURE__*/(() => {
  class MetaClient {
    pixelId = '1633509306879336';
    load() {
      metaPixel(this.pixelId);
    }
    getDefaultUserData() {
      return {
        fbc: cookieService.getCookie(PixelClickIdCookie._fbc) || formatMetaClickId(cookieService.getCookie('fbclid')),
        fbp: cookieService.getCookie(PixelClickIdCookie._fbp)
      };
    }
    pageView({
      id
    }) {
      this.load();
      window.fbq('track', 'ViewContent', {
        user_data: this.getDefaultUserData()
      }, {
        eventID: id
      });
    }
    lead({
      id
    }) {
      this.load();
      window.fbq('track', 'Lead', {
        user_data: this.getDefaultUserData()
      }, {
        eventID: id
      });
    }
    addToCart({
      id,
      amount,
      currency,
      plan
    }) {
      this.load();
      window.fbq('track', 'AddToCart', {
        content_name: plan,
        value: amount,
        currency,
        user_data: this.getDefaultUserData()
      }, {
        eventID: id
      });
    }
    purchase({
      id,
      amount,
      currency,
      plan,
      hashedEmail,
      hashedPhone
    }) {
      this.load();
      const eventData = {
        content_name: plan,
        value: amount,
        currency,
        user_data: {
          ...this.getDefaultUserData(),
          em: hashedEmail,
          ph: hashedPhone
        }
      };
      window.fbq('track', 'Purchase', eventData, {
        eventID: id
      });
      window.fbq('trackCustom', 'NC123', eventData, {
        eventID: id
      });
    }
    postPurchase({
      id
    }) {
      this.load();
      window.fbq('trackCustom', 'NCABC', {}, {
        eventID: id
      });
    }
  }
  __decorate([_Memo()], MetaClient.prototype, "load", null);
  return MetaClient;
})();
export const metaClient = new MetaClient();